export default "__VITE_ASSET__08725e95__"